<!-- eslint-disable @angular-eslint/template/no-call-expression -->
@if (holygrail2()) {
    <div class="skeleton-media">
        <div class="skeleton-img ar-{{ ratio() }}"></div>
        @if (skeletonTextPosition() !== position.none) {
            <div class="skeleton-txt"></div>
        }
    </div>
} @else {
    <div class="sk-load_{{ ratio() }}">
        <div class="p-view">
            <div class="rat-{{ ratio() }}">
                <div class="rat-content">
                    <ng-content select="[skeletonMedia]"></ng-content>
                    <ng-content select="[skeletonBadge]"></ng-content>
                </div>
            </div>
        </div>

        <ng-content select="[skeletonFooter]"></ng-content>
    </div>
}
